import React, { PureComponent, Component } from 'react';
import {
    BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
    LineChart, Line,
    PieChart, Pie, Sector, ResponsiveContainer
} from 'recharts';
import { connect } from 'react-redux';
import '../Home.css'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { bindActionCreators } from 'redux'
import moment from "moment";
import ComboboxInput from "../PushInteractive/ComboboxInputCustom";
import { fromJS } from "immutable";
import { ClientId, PrevilageId, SenderId, DivisionId } from "../../helper/HelperAuth";
import ActionGetAllSender from "../../store/action/Sender/FetchAll";
import ActionGetReportSessionDashboard from "../../store/action/ReportSession/Dashboard"
import { toast } from "react-toastify";
import ActionGetAccessModule from "../../store/action/AccessModule/Fetch";
import ActionGetClient from '../../store/action/Client/FetchAll'
import DatePickerInput from "../../infra/components/formInput/DatePickerInput";
import { Route } from "react-router-dom";
import ActionGetAllDivision from "../../store/action/Division/FetchAll";
class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: "Report Pricing",
            dates: moment().format('D MMMM YYYY') + " - " + moment().format('D MMMM YYYY'),
            form: fromJS({
                'client': ClientId,
                'sender': SenderId,
                'tahun': "",
                'bulan': "",
                'tanggal-mulai': "",
                'tanggal-selesai': "",
                "division-id": DivisionId,
                "batch-name": ""
            }),
            hidecliet: 'hide',
            initstart: moment().format('MM/D/YYYY').toString(),
            initend: moment().format('MM/D/YYYY').toString(),
            startDate: '',
            endDate: '',
            intertotick: 0,
            interinquiry: 0,
            interaverage: 0,
            tooltip: "",
            dissender: true,
            errors: fromJS({}),
            dataDailyMessageByStatus: [],
            dataPushFormat: [],
            dataHighestReadRate: '',
            loaderStyle: {},
            actionid: '',
            colhide: '"forms-groups cols-sm-6"',
            dataReportSession: [],
            totalConversation: 0,
            authenticationCategory: 0,
            marketingCategory: 0,
            utilityCategory: 0,
            serviceCategory: 0,

        };

        this.handleChange = this.handleChange.bind(this)
        this.handleCallback = this.handleCallback.bind(this)
        this.handleref = this.handleref.bind(this)
        this.handlebody = this.handlebody.bind(this)
    }

    handleActionId() {
        let array = []
        let action = 0;
        let menuPrev = (this.props.accessmodules.get('data') != null ? this.props.accessmodules.get('data') : fromJS([]));
        {
            menuPrev.map((data, i) =>
                array.push({
                    'menu-name': data.get('menu-name'),
                    'action-id': data.get('action-id')
                })

            )
        }

        for (let i = 0; i < array.length; i++) {
            if (array[i]['menu-name'] === 'Push Summary') {
                action = array[i]['action-id'];
                this.state.action_id = array[i]['action-id'];
            }
        }
        return action;
    }

    async handleChange(field, value, label) {
        let formVal = this.state.form;
        let newDate = new Date()

        let startDate = newDate.getDate();
        let endDate = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();


        if (formVal.get('tahun') !== '') {
            year = formVal.get('tahun')
        }

        if (formVal.get('bulan') !== '') {
            month = formVal.get('bulan')
        }

        if (formVal.get('tanggal-mulai') !== '') {
            startDate = formVal.get('tanggal-mulai')
        }

        if (formVal.get('tanggal-selesai') !== '') {
            endDate = formVal.get('tanggal-selesai')
        }

        if (value == null) {
            value = "";
        }
        if (field == 'client') {
            if (value == '') {
                this.props.actionGetAllSender(ClientId, DivisionId)
            } else {
                this.props.actionGetAllSender(value)
                this.props.actionGetAllDivision(value)
            }
            formVal = formVal.set('sender', '')
            formVal = formVal.set('division-id', '')
        }

        if (field == 'sender') {
            if (value == "") {
                toast.warn('Sender cannot be empty');
                return false
            }
        }

        if (field === 'division-id') {
            if (value === "") {
                toast.warn('division cannot be empty');
                return false
            }

            this.props.actionGetAllSender(formVal.get('client'), value)
        }
        formVal = formVal.set(field, value);

        this.setState({ form: formVal })
        if (formVal.get('sender') == "") {
            toast.warn('Sender cannot be empty');
        } else {
            let body = {
                "sender": formVal.get('sender'),
                "tahun": year.toString(),
                "bulan": month.toString(),
                "tanggal-mulai": startDate.toString(),
                "tanggal-selesai": endDate.toString(),
                "templatename": formVal.get("template-name"),
                "batchname": formVal.get("batch-name")
            }


            if (startDate < 10) startDate = "0" + startDate
            if (endDate < 10) endDate = "0" + endDate

            if (month < 10) month = "0" + month

            let bodySession = {
                "client-id": formVal.get('client'),
                "division-id": formVal.get('division-id'),
                "sender-id": formVal.get('sender'),
                "start-date": year + "-" + month + "-" + startDate,
                "end-date": year + "-" + month + "-" + endDate
            }
            this.setState({ loaderStyle: {} })
            let dataReportSessionDashboard = await this.props.actionGetReportSessionDashboard(bodySession)
            if (null == dataReportSessionDashboard) {
                this.setState({
                    loaderStyle: { display: 'none' }
                })
            } else {
                this.setState({
                    loaderStyle: { display: 'none' },
                    totalConversation: dataReportSessionDashboard['total-total-conversation'],
                    authenticationCategory: dataReportSessionDashboard['total-authentication'],
                    marketingCategory: dataReportSessionDashboard['total-marketing'],
                    utilityCategory: dataReportSessionDashboard['total-utility'],
                    serviceCategory: dataReportSessionDashboard['total-service'],
                    dataReportSession: dataReportSessionDashboard['chart']
                })
            }
        }
    }

    async handleref(start, end) {
        await this.handlebody(start, end)
    }

    async handlebody(start, end) {
        let formVal = this.state.form
        const { form } = this.state
        let arraystart = start.split("/")
        let arrayend = end.split("/")
        let bulan = arraystart[0]
        let tahun = arraystart[2]
        let tglstart = arraystart[1]
        let tglend = arrayend[1]
        let bulanEnd = arrayend[0]

        if (bulan != bulanEnd) {
            toast.warn('Start and end dates must be in the same period (month, year)');
            return
        }
        if (form.get("client") === null
            || form.get("client") === ""
            || form.get("sender") === null
            || form.get("sender") === ""
            || form.get("division-id") === null
            || form.get("division-id") === "") return false, toast.error("Client or Division or Sender Cannot Be Empty", toast.POSITION.BOTTOM_RIGHT)

        if (bulan[0] == "0") bulan = bulan[1]

        if (tglstart[0] == "0") tglstart = tglstart[0]

        if (tglend[0] == "0") tglend = tglend[0]
        
        formVal = formVal.set("tahun", tahun)
            .set("bulan", bulan)
            .set("tanggal-mulai", tglstart)
            .set("tanggal-selesai", tglend)

        this.setState({ form: formVal })

        if (tglstart < 10) tglstart = "0" + tglstart
        if (tglend < 10) tglend = "0" + tglend
        if (bulan < 10) bulan = "0" + bulan

        let bodySession = {
            "client-id": formVal.get('client'),
            "division-id": formVal.get('division-id'),
            "sender-id": formVal.get('sender'),
            "start-date": tahun + "-" + bulan + "-" + tglstart,
            "end-date": tahun + "-" + bulan + "-" + tglend
        }
        this.setState({ loaderStyle: {} })
        let dataReportSessionDashboard = await this.props.actionGetReportSessionDashboard(bodySession)
        if (null == dataReportSessionDashboard) {
            this.setState({
                loaderStyle: { display: 'none' }
            })
        } else {
            this.setState({
                loaderStyle: { display: 'none' },
                totalConversation: dataReportSessionDashboard['total-total-conversation'],
                authenticationCategory: dataReportSessionDashboard['total-authentication'],
                marketingCategory: dataReportSessionDashboard['total-marketing'],
                utilityCategory: dataReportSessionDashboard['total-utility'],
                serviceCategory: dataReportSessionDashboard['total-service'],
                dataReportSession: dataReportSessionDashboard['chart'],
            })
        }
    }

    handleCallback(start, end, label) {
        let starts = start.format('MM/D/YYYY').toString()
        let ends = end.format('MM/D/YYYY').toString()
        let dated = start.format('D MMMM YYYY') +
            " - " + end.format('D MMMM YYYY')
        this.handleref(starts, ends)
        this.setState({ dates: dated })
    }

    async componentDidMount() {
        if (PrevilageId > 1) {
            this.setState({ hideclient: 'hide', colhide: 'forms-groups cols-sm-6' })
        } else {
            this.setState({ hideclient: '', colhide: 'forms-groups cols-sm-4' })
        }
        this.props.actionGetClient();
        this.props.actionGetAllSender(ClientId)
        this.props.actionGetAllDivision(ClientId)
        await this.props.actionGetAccessModule(PrevilageId);
        let restrict = this.handleActionId()
        let dissen = this.state.dissender
        this.handleref(this.state.initstart, this.state.initend)
        this.setState({ dissender: dissen, actionid: restrict })
    }

    render() {
        const { title, loaderStyle } = this.state;
        const { form, searchForm, errors } = this.state;
        return (
            <div>
                <div className="page-loader-wrapper" style={loaderStyle}>
                    <div className="loader">
                        <div className="preloader">
                            <div className="spinner-layer pl-orange">
                                <div className="circle-clipper left">
                                    <div className="circle"></div>
                                </div>
                                <div className="circle-clipper right">
                                    <div className="circle"></div>
                                </div>
                            </div>
                        </div>
                        <p>Please wait...</p>
                    </div>
                </div>
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="rows mb-2">
                            <div className="cols-sm-2">
                                <h1 className="m-0 titles-card-head">Report Pricing</h1>
                            </div>
                        </div>
                        <div className="card">
                            <div className="body">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <ComboboxInput
                                            field='client'
                                            value={form.get('client')}
                                            options={fromJS({
                                                'source': this.props.clientall,
                                                'value': 'client-id',
                                                'label': 'client-name'
                                            })}
                                            onChange={(field, value, label) => this.handleChange(field, value, label)}
                                            placeholder="Client"
                                            disabled={false}
                                        // disabled={this.state.dissender}
                                        />
                                    </div>
                                    <div className="col-sm-3">
                                        <ComboboxInput
                                            field='division-id'
                                            value={form.get('division-id')}
                                            options={fromJS({
                                                'source': this.props.divisionall,
                                                'value': 'division-id',
                                                'label': 'division-name'
                                            })}
                                            onChange={(field, value, label) => this.handleChange(field, value, label)}
                                            placeholder="Division"
                                            disabled={false}
                                            hasError={errors.has('division-id')}
                                        />
                                    </div>
                                    <div className="col-sm-3">
                                        <ComboboxInput
                                            field='sender'
                                            value={form.get('sender')}
                                            options={fromJS({
                                                'source': this.props.senderall,
                                                'value': 'sender-id',
                                                'label': 'sender-id-name'
                                            })}
                                            onChange={(field, value, label) => this.handleChange(field, value, label)}
                                            placeholder="Sender"
                                            disabled={false}
                                            hasError={errors.has('sender')}
                                        />
                                    </div>
                                    <div className="col-sm-3">
                                        <DateRangePicker
                                            initialSettings={{
                                                startDate: moment().format('MM/D/YYYY').toString(),
                                                endDate: moment().format('MM/D/YYYY').toString(),
                                                ranges: {
                                                    Today: [moment().toDate(), moment().toDate()],
                                                    Yesterday: [
                                                        moment().subtract(1, 'days').toDate(),
                                                        moment().subtract(1, 'days').toDate(),
                                                    ],
                                                    'Last 7 Days': [
                                                        moment().subtract(6, 'days').toDate(),
                                                        moment().toDate(),
                                                    ],
                                                    'Last 30 Days': [
                                                        moment().subtract(29, 'days').toDate(),
                                                        moment().toDate(),
                                                    ],
                                                    'This Month': [
                                                        moment().startOf('month').toDate(),
                                                        moment().endOf('month').toDate(),
                                                    ],
                                                    'Last Month': [
                                                        moment().subtract(1, 'month').startOf('month').toDate(),
                                                        moment().subtract(1, 'month').endOf('month').toDate(),
                                                    ],
                                                }
                                            }}
                                            onCallback={this.handleCallback}
                                        >
                                            <div class="cols-sm-12 floats-right calendar">
                                                <i class="fa fa-calendar"></i>&nbsp;&nbsp;
                                                <span>{this.state.dates}</span> <i class="fa fa-caret-down"></i>
                                            </div>
                                        </DateRangePicker>
                                    </div>


                                    <div className="col-sm-2">
                                        {/*// <Link to="/ReportHelpdesk" className="btn btn-warning">Report List</Link>*/}
                                        <Route render={({ history }) => (
                                            <button
                                                className="btn btn-warning"
                                                type='button'
                                                onClick={event => window.location.href = '/ReportSessionList'}
                                            >
                                                Report List
                                            </button>
                                        )} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid">
                        <div className="rows">
                            <div className="cols-lg-12">
                                <div className="content">
                                    <div className="rows">
                                        <div className="cols-lg-4">
                                            <div className="card">
                                                <div className="body">
                                                    <div className="row">
                                                        <div className="col-sm-9">
                                                            <h5>Total Conversation</h5>
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <h5>{this.state.totalConversation}</h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-9">
                                                            <h5>Authentication</h5>
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <h5>{this.state.authenticationCategory}</h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-9">
                                                            <h5>Marketing</h5>
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <h5>{this.state.marketingCategory}</h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-9">
                                                            <h5>Utility</h5>
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <h5>{this.state.utilityCategory}</h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-9">
                                                            <h5>Service</h5>
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <h5>{this.state.serviceCategory}</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="cols-lg-8">
                                            <div className="cards">
                                                <div className="cards-body">
                                                    <ResponsiveContainer width='100%' height={350}>
                                                        <LineChart
                                                            height={350}
                                                            data={this.state.dataReportSession}
                                                            margin={{
                                                                top: 5,
                                                                right: 30,
                                                                left: 20,
                                                                bottom: 5
                                                            }}
                                                        >
                                                            <CartesianGrid strokeDasharray="3 3" />
                                                            <XAxis dataKey="date" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Line
                                                                type="monotone"
                                                                dataKey="Authentication"
                                                                stroke="#FF6C20"
                                                                activeDot={{ r: 8 }}
                                                            />
                                                            <Line
                                                                type="monotone"
                                                                dataKey="Marketing"
                                                                stroke="#bf1d32"
                                                                activeDot={{ r: 8 }}
                                                            />
                                                            <Line
                                                                type="monotone"
                                                                dataKey="Utility"
                                                                stroke="#38a62e"
                                                                activeDot={{ r: 8 }}
                                                            />
                                                            <Line
                                                                type="monotone"
                                                                dataKey="Service"
                                                                stroke="#87ceeb"
                                                                activeDot={{ r: 8 }}
                                                            />
                                                            <Line
                                                                type="monotone"
                                                                dataKey="Total Conversation"
                                                                stroke="#0088FE"
                                                                activeDot={{ r: 8 }}
                                                            />
                                                        </LineChart>
                                                    </ResponsiveContainer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            isLoggedIn: state.auth.isLoggedIn,
            senderall: state.user.senders,
            divisionall: state.user.divisionall,
            accessmodules: state.user.accessmodules,
            clientall: state.user.clientall,
            reportsessiondashboard: state.user.reportsessiondashboard
        }
    },
    dispatch => bindActionCreators({
        actionGetAccessModule: ActionGetAccessModule,
        actionGetAllSender: ActionGetAllSender,
        actionGetReportSessionDashboard: ActionGetReportSessionDashboard,
        actionGetClient: ActionGetClient,
        actionGetAllDivision: ActionGetAllDivision,
    }, dispatch),
)(Page);